import React from 'react';
import '../../../styles/components/loadingIndicator.css';

/**
 * A reusable loading indicator component
 * @param {Object} props - Component props
 * @param {string} [props.size="large"] - Size of the spinner (small, medium, large)
 * @param {boolean} [props.fullPage=true] - Whether to display the spinner centered on the full page
 * @param {boolean} [props.inline=false] - Compact horizontal layout for use beside controls
 * @param {string} [props.color="#16a085"] - Primary color of the spinner (defaults to app theme color)
 * @param {string} [props.text] - Optional status text (below spinner, or beside it when inline)
 * @param {string} [props.className] - Optional extra class names
 */
const LoadingIndicator = ({
    size = "large",
    fullPage = true,
    inline = false,
    color = "#16a085", // Brighter version of our theme green
    text,
    className = "",
}) => {
    const classes = [
        "loading-indicator",
        fullPage && !inline ? "full-page" : "",
        inline ? "loading-indicator--inline" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={classes} role="status" aria-live="polite" aria-busy="true">
            <div className={`spinner ${size}`}>
                <div className="spinner-inner" style={{ borderTopColor: color }}></div>
            </div>
            {text ? <div className="loading-text">{text}</div> : null}
        </div>
    );
};

export default LoadingIndicator;